module.exports = __webpack_public_path__ + "img/sintesis.d116ae9a.svg";